import React from 'react';
import { Stack } from '@mui/material';
import { ListEmpty } from 'components/shared/List';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { DashboardOption } from '../types';
import { DashboardListItem } from './DashboardListItem';

interface Props {
  dashboardOptionList: DashboardOption[];
  onDashboardSelect?: (dashboard: DashboardOption) => void;
}

export const DashboardList = ({ dashboardOptionList, onDashboardSelect }: Props) => {
  return (
    <RenderWithCondition condition={!!dashboardOptionList.length} fallBack={<ListEmpty />}>
      <Stack gap="0.5rem">
        {dashboardOptionList.map(dashboardOption => (
          <DashboardListItem key={dashboardOption.id} dashboardOption={dashboardOption} onSelect={onDashboardSelect} />
        ))}
      </Stack>
    </RenderWithCondition>
  );
};
